import { GET_COMMENTS, CREATE_COMMENT, DESTROY_COMMENT } from "./actions";
import { COMMENT_CABLE_EVENT } from "channels/comments_channel";

export function CommentsReducer(state = {}, action) {
  switch (action.type) {
    case `${GET_COMMENTS}_FULFILLED`: {
      let newState = _.cloneDeep(state);
      const { commentableType, commentableId } = action.meta || {};
      // Replace this commentable's comments so deletes/refetches stay accurate
      if (commentableType && commentableId != null) {
        newState = _.omitBy(
          newState,
          (c) =>
            c.commentable_type === commentableType &&
            String(c.commentable_id) === String(commentableId)
        );
      }
      _.each(action.payload.data, (item) => {
        newState[item.id] = item;
      });
      return newState;
    }
    case `${CREATE_COMMENT}_FULFILLED`: {
      const newItem = action.payload?.data;
      if (!newItem?.id) return state;
      const newState = _.clone(state);
      newState[newItem.id] = newItem;
      return newState;
    }
    case `${DESTROY_COMMENT}_FULFILLED`: {
      const id = _.get(action.payload, "data.id");
      if (!id) return state;
      const newState = _.clone(state);
      delete newState[id];
      return newState;
    }
    case COMMENT_CABLE_EVENT: {
      const { action: cableAction, comment } = action.payload || {};
      if (!comment?.id) return state;
      const newState = _.clone(state);
      if (cableAction === "destroyed") {
        delete newState[comment.id];
        return newState;
      }
      // created (or upsert)
      newState[comment.id] = comment;
      return newState;
    }
    default:
      return state;
  }
}
